import { Injectable } from '@angular/core';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Injectable({
  providedIn: 'root',
})
export class PdfGeneratorService {
  doc: jsPDF | undefined;
  linkRefs: any[] = [];

  newInstance() {
    this.doc = new jsPDF();
    return this;
  }

  addTableByRef(tableId: string) {
    autoTable(this.doc, { html: tableId });
  }

  addTable(headers: any, body: any, footer = []) {
    if (footer.length > 0) {
      const formattedFooter = footer.map((f) => {
        return {
          content: f,
          styles: { fontStyle: 'bold' },
        };
      });
      body.push(formattedFooter);
    }

    autoTable(this.doc, {
      head: headers,
      body,
      didParseCell: (hookData) => {
        if (
          hookData.cell.raw &&
          hookData.cell.raw.toString().includes('http')
        ) {
          const rowIndex = hookData.row.index;
          const cellValue = hookData.cell.raw;
          this.linkRefs.push({ rowIndex, cellValue });

          hookData.cell.width = 15;
          hookData.column.width = 15;
          hookData.cell.text = ['  ver'];
        }
      },
      willDrawCell: (hookData) => {
        if (
          hookData.cell.raw &&
          hookData.cell.raw.toString().includes('http')
        ) {
          const linkRef = this.linkRefs.find(
            (link) => link.rowIndex === hookData.row.index
          );
          if (!linkRef) {
            return;
          }

          hookData.doc.textWithLink(
            '  ver',
            hookData.cell.getTextPos().x,
            hookData.cell.getTextPos().y + 3,
            {
              url: linkRef.cellValue,
            }
          );
        }
      },
    });
  }

  addText(text: string | string[], posX: number, posY: number) {
    if (this.doc === undefined) {
      return;
    }

    this.doc.setFontSize(8);
    this.doc.text(text, posX, posY);
  }

  addLink(url: string, title: string, posX: number, posY: number) {
    if (this.doc === undefined) {
      return;
    }

    this.doc.textWithLink(title, posX, posY, { url });
  }

  save(docName: string) {
    if (this.doc === undefined) {
      return;
    }

    this.doc.save(`${docName}.pdf`);
    this.linkRefs = [];
  }
}
